export const minutesArray = Array.from({ length: 60 }, (_, i) => i);
export const meridianArray = ["AM", "PM"];
export const hoursArray = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];
/**
 * Converts a date to the format "MMM dd, YYYY" (e.g., "Jan 01, 2023")
 * @param date - The date to format. Defaults to current date if not provided.
 * @returns The formatted date string
 */
export function formatDate(date: Date = new Date()): string {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = months[date.getMonth()];
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
}
// TIME PICKER CONSTANTS

export function getSelectedTime24(
  hrs: number,
  minutes: number,
  meridian: number
): string {
  const selectedHour = parseInt(hoursArray[hrs], 10);
  const selectedMinute = minutesArray[minutes]; // Use the minutes state directly
  const selectedMeridian = meridianArray[meridian];

  let hour24;

  if (selectedMeridian === "AM") {
    if (selectedHour === 12) {
      // 12 AM -> 00 (midnight)
      hour24 = 0;
    } else {
      // 1 AM - 11 AM -> 01 - 11
      hour24 = selectedHour;
    }
  } else {
    // PM
    if (selectedHour === 12) {
      // 12 PM -> 12 (noon)
      hour24 = 12;
    } else {
      // 1 PM - 11 PM -> 13 - 23
      hour24 = selectedHour + 12;
    }
  }

  return `${hour24.toString().padStart(2, "0")}:${selectedMinute
    .toString()
    .padStart(2, "0")}`;
}
export const syncTimePickerWithSettings = (time: string) => {
  if (time) {
    const [hours, mins] = time.split(":");
    const hourNum = parseInt(hours);
    const minuteValue = parseInt(mins);

    let hour12;
    let meridian;

    if (hourNum === 0) {
      // Midnight (00:xx) -> 12:xx AM
      hour12 = 12;
      meridian = 0; // AM
    } else if (hourNum < 12) {
      // Morning (01:xx - 11:xx) -> 1:xx AM - 11:xx AM
      hour12 = hourNum;
      meridian = 0; // AM
    } else if (hourNum === 12) {
      // Noon (12:xx) -> 12:xx PM
      hour12 = 12;
      meridian = 1; // PM
    } else {
      // Afternoon/Evening (13:xx - 23:xx) -> 1:xx PM - 11:xx PM
      hour12 = hourNum - 12;
      meridian = 1; // PM
    }

    const hourIndex = hour12 - 1;
    return {
      hrs: hourIndex >= 0 ? hourIndex : 0, // Ensure index is within bounds
      minutes: minuteValue >= 0 ? minuteValue : 0, // Ensure minutes are valid
      meridian, // 0 for AM, 1 for PM
    };
  }
};
/**
 * Returns today's date formatted as "YYYY-MM-DD"
 * @returns {string} The formatted date string
 */
export function getTodayFormatted(): string {
  const localDate = new Date();
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const day = String(localDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
  export const getDateRange = () => {
    const today = new Date();
    const monday = new Date(today);
    const dayOfWeek = today.getDay();
    const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    monday.setDate(today.getDate() - diff);
  
    const startDate = new Date(
      monday.getFullYear(),
      monday.getMonth(),
      monday.getDate(),
      0,
      0,
      0,
      0
    );
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    const endDate = new Date(
      sunday.getFullYear(),
      sunday.getMonth(),
      sunday.getDate(),
      23,
      59,
      59,
      999
    );
    return {
      startDate: startDate.toLocaleDateString("en-CA"),
      endDate: endDate.toLocaleDateString("en-CA"),
    };
  };
  export const formatDateInsights = (
    dateStr: string,
    index: number,
    data: any[],
    dataLengthInfo: {
      moreThan7Days: boolean;
      yearlyData: boolean;
    }
  ) => {
    // For yearly data, only year and month are present (no day)
    const [year, month, day] = dateStr.split("T")[0].split("-").map(Number);
    let date;
    if (dataLengthInfo.yearlyData) {
      // Only year and month
      date = new Date(year, month - 1, 1);
    } else {
      date = new Date(year, month - 1, day);
    }
    if (!dataLengthInfo.moreThan7Days) {
      return date.toLocaleDateString("en-US", { weekday: "short" });
    }

    const monthStr = date.toLocaleDateString("en-US", { month: "short" });
    const dayNum = date.getDate();
    if (dataLengthInfo.yearlyData) {
      return monthStr;
    }

    // Check if month changed from previous entry
    if (index > 0) {
      const prevDate = new Date(data[index - 1].date);
      const isSameMonth = prevDate.getMonth() === date.getMonth();
      return isSameMonth ? `${dayNum}` : `${monthStr} ${dayNum}`;
    }

    return `${monthStr} ${dayNum}`;
  };